export const messages = {
  canceled: 'This operation has been canceled!',
  canceledTransfer: 'This transfer has been canceled!',
  canceledVoting: 'Your voting has been canceled!',
  canceledVote: 'Your vote has been canceled!',
  canceledOrder: 'Your order has been canceled!',
  canceledTrade: 'Your trade has been canceled!',
  notCanceledOrder: 'Your order cannot been canceled!',
  notAcceptedTrade: 'Your trade cannot be accepted!',
  addressNotUsed: 'This address can not be used!',
  transferNotApproved: 'Token transfer cannot been approved!',
  transferNotRejected: 'Token transfer cannot been rejected!',
  tradeNotApproved: 'Trade cannot been approved!',
  tradeNotRejected: 'Trade cannot been rejected!',
}